<app-base-dialog
  [(visible)]="visible"
  title="common.language"
  testId="language-select-dialog"
  width="400px"
  submitLabel="common.apply"
  (submitted)="onApply()"
>
  <app-model-field-select
    id="language-select-dialog-language"
    [options]="languageOptions"
    optionLabel="value"
    optionValue="key"
    [showClear]="false"
    [(value)]="language"
  />
</app-base-dialog>
